import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


function membership() {
    return (
        <section id='membership' className='membership pt-3 pb-0'>
            <div className='container'>
                <div className='wrappar rounded-4 p-xl-5 py-5 p-md-4 p-3'>
                    <div className='heading-sec px-md-5 mb-5 text-center m-auto'>
                        <div className='strip-heading'>Pricing</div>
                        <h2 className='h3-heading text-dark'>Value-Packed Plans</h2>
                        <div className='h5-heading mb-3'>Get the most out of your investment with our comprehensive packages.</div>
                        <p>Etiam sed odio dictum, tempus velit non, sollicitudin neque. Donec quis aliquet velit. Aliquam convallis dapibus purus. Etiam sed odio dictum, tempus velit non, sollicitudin neque.</p>
                    </div>
                    <div className='row g-4'>
                        <div className='col-lg-6'>
                            <div className='rounded-4 bg-light p-lg-5 p-4 box-shadow'>
                                <div className='strip-heading mb-0'>Basic</div>
                                <div className='h2-heading fw-600 price'>$2,900 <span class="fs-6">/ basic</span></div>
                                <p>Ideal for small businesses and startups needing a consistent.</p>
                                <a className='btn btn-dark w-100 rounded-5' href='#'>Get this plan</a>
                                <div className='features mt-4'>
                                    <ul>
                                        <li className='mb-3'>
                                            <strong className='d-block mb-1'>Custom Web Design</strong>
                                            <p>Unique, responsive design tailored to your brand.</p>
                                        </li>
                                        <li className='mb-3'>
                                            <strong className='d-block mb-1'>10 Pages</strong>
                                            <p>Home, About, Services, Blog, Contact, Portfolio, Testimonials, Team, FAQs, Privacy Policy.</p>
                                        </li>
                                        <li className='mb-3'>
                                            <strong className='d-block mb-1'>SEO Optimization</strong>
                                            <p>Improve search engine rankings.</p>
                                        </li>
                                        <li className='mb-3'>
                                            <strong className='d-block mb-1'>Content Management System</strong>
                                            <p>Easy content updates.</p>
                                        </li>
                                        <li className='mb-3'>
                                            <strong className='d-block mb-1'>Monthly Updates</strong>
                                            <p>Regular site updates.</p>
                                        </li>
                                        <li className='mb-0'>
                                            <strong className='d-block mb-1'>Support</strong>
                                            <p className='mb-0'>Continuous technical support.</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className='rounded-4 bg-light p-lg-5 p-4 box-shadow'>
                                <div className='strip-heading mb-0'>Advance</div>
                                <div className='h2-heading fw-600 price'>$3,900 <span class="fs-6">/ advance</span></div>
                                <p>Ideal for small businesses and startups needing a consistent.</p>
                                <a className='btn btn-primary w-100 rounded-5' href='#'>Get this plan</a>
                                <div className='features mt-4'>
                                    <ul>
                                        <li className='mb-3'>
                                            <strong className='d-block mb-1'>Advanced Custom Web Design</strong>
                                            <p>Fully customized, responsive design.</p>
                                        </li>
                                        <li className='mb-3'>
                                            <strong className='d-block mb-1'>20 Pages</strong>
                                            <p>Home, About, Services, Blog, Contact, Portfolio, Testimonials, Team, FAQs, Privacy Policy + other 10 pages</p>
                                        </li>
                                        <li className='mb-3'>
                                            <strong className='d-block mb-1'>Advanced SEO Optimization</strong>
                                            <p>In-depth SEO for better visibility.</p>
                                        </li>
                                        <li className='mb-3'>
                                            <strong className='d-block mb-1'>Enhanced CMS & Blog Setup</strong>
                                            <p>Advanced features and training.</p>
                                        </li>
                                        <li className='mb-3'>
                                            <strong className='d-block mb-1'>E-Commerce Integration</strong>
                                            <p>Online store setup (20 products).</p>
                                        </li>
                                        <li className='mb-0'>
                                            <strong className='d-block mb-1'>Priority Support</strong>
                                            <p className='mb-0'>Fast support and performance reviews.</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                <div className='col-12'>
                    <div className='rounded-4 bg-light p-lg-5 p-md-4 py-4 p-3 box-shadow text-center'>
                        <div className='strip-heading'>Exclusive</div>
                        <div className='h4-heading mb-2'>Custom IT Solutions Tailored for You</div>
                        <p className='mb-4 px-md-5'>Share your unique requirements with us to receive a personalized service plan that meets your business goals. Let’s collaborate to find the perfect solution!</p>
                        <a href='#' className='btn btn-primary px-5 py-4 rounded-5'>Get Started Today</a>
                    </div>
                </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default membership
